(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[620],{

/***/ 8688:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prior-authorization",
      function () {
        return __webpack_require__(6575);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ prior_authorization; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ./components/SEO/SEO.js + 1 modules
var SEO = __webpack_require__(3976);
// EXTERNAL MODULE: ./layout/Layout.js + 6 modules
var Layout = __webpack_require__(9875);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-disposables.js
var use_disposables = __webpack_require__(4192);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(3781);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var use_iso_morphic_effect = __webpack_require__(6723);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-is-mounted.js
function f(){let e=(0,react.useRef)(!1);return (0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>(e.current=!0,()=>{e.current=!1}),[]),e}

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-flags.js
function c(a=0){let[l,r]=(0,react.useState)(a),t=f(),o=(0,react.useCallback)(e=>{t.current&&r(u=>u|e)},[l,t]),m=(0,react.useCallback)(e=>Boolean(l&e),[l]),s=(0,react.useCallback)(e=>{t.current&&r(u=>u&~e)},[r,t]),g=(0,react.useCallback)(e=>{t.current&&r(u=>u^e)},[r]);return{flags:l,addFlag:o,hasFlag:m,removeFlag:s,toggleFlag:g}}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-latest-value.js
var use_latest_value = __webpack_require__(3855);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-server-handoff-complete.js
var use_server_handoff_complete = __webpack_require__(2180);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(3784);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/disposables.js + 1 modules
var disposables = __webpack_require__(8043);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/match.js
var match = __webpack_require__(2984);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/utils/once.js
function once_l(r){let e={called:!1};return(...t)=>{if(!e.called)return e.called=!0,r(...t)}}

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/transitions/utils/transition.js
function g(t,...e){t&&e.length>0&&t.classList.add(...e)}function v(t,...e){t&&e.length>0&&t.classList.remove(...e)}function b(t,e){let n=(0,disposables/* disposables */.k)();if(!t)return n.dispose;let{transitionDuration:m,transitionDelay:a}=getComputedStyle(t),[u,p]=[m,a].map(l=>{let[r=0]=l.split(",").filter(Boolean).map(i=>i.includes("ms")?parseFloat(i):parseFloat(i)*1e3).sort((i,T)=>T-i);return r}),o=u+p;if(o!==0){n.group(r=>{r.setTimeout(()=>{e(),r.dispose()},o),r.addEventListener(t,"transitionrun",i=>{i.target===i.currentTarget&&r.dispose()})});let l=n.addEventListener(t,"transitionend",r=>{r.target===r.currentTarget&&(e(),l())})}else e();return n.add(()=>e()),n.dispose}function M(t,e,n,m){let a=n?"enter":"leave",u=(0,disposables/* disposables */.k)(),p=m!==void 0?once_l(m):()=>{};a==="enter"&&(t.removeAttribute("hidden"),t.style.display="");let o=(0,match/* match */.E)(a,{enter:()=>e.enter,leave:()=>e.leave}),l=(0,match/* match */.E)(a,{enter:()=>e.enterTo,leave:()=>e.leaveTo}),r=(0,match/* match */.E)(a,{enter:()=>e.enterFrom,leave:()=>e.leaveFrom});return v(t,...e.base,...e.enter,...e.enterTo,...e.enterFrom,...e.leave,...e.leaveFrom,...e.leaveTo,...e.entered),g(t,...e.base,...o,...r),u.nextFrame(()=>{v(t,...e.base,...o,...r),g(t,...e.base,...o,...l),b(t,()=>(v(t,...e.base,...o),g(t,...e.base,...e.entered),p()))}),u.dispose}

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-transition.js
function use_transition_D({immediate:t,container:s,direction:n,classes:u,onStart:a,onStop:c}){let l=f(),d=(0,use_disposables/* useDisposables */.G)(),e=(0,use_latest_value/* useLatestValue */.E)(n);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{t&&(e.current="enter")},[t]),(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{let r=(0,disposables/* disposables */.k)();d.add(r.dispose);let i=s.current;if(i&&e.current!=="idle"&&l.current)return r.dispose(),a.current(e.current),r.add(M(i,u.current,e.current==="enter",()=>{r.dispose(),c.current(e.current)})),r.dispose},[n])}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/open-closed.js
var open_closed = __webpack_require__(6567);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/class-names.js
var class_names = __webpack_require__(4067);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/render.js
var render = __webpack_require__(2351);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js
function S(t=""){return t.split(/\s+/).filter(n=>n.length>1)}let I=(0,react.createContext)(null);I.displayName="TransitionContext";var Se=(r=>(r.Visible="visible",r.Hidden="hidden",r))(Se||{});function ye(){let t=(0,react.useContext)(I);if(t===null)throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");return t}function xe(){let t=(0,react.useContext)(transition_M);if(t===null)throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");return t}let transition_M=(0,react.createContext)(null);transition_M.displayName="NestingContext";function U(t){return"children"in t?U(t.children):t.current.filter(({el:n})=>n.current!==null).filter(({state:n})=>n==="visible").length>0}function se(t,n){let r=(0,use_latest_value/* useLatestValue */.E)(t),s=(0,react.useRef)([]),R=f(),D=(0,use_disposables/* useDisposables */.G)(),p=(0,use_event/* useEvent */.z)((i,e=render/* RenderStrategy.Hidden */.l4.Hidden)=>{let a=s.current.findIndex(({el:o})=>o===i);a!==-1&&((0,match/* match */.E)(e,{[render/* RenderStrategy.Unmount */.l4.Unmount](){s.current.splice(a,1)},[render/* RenderStrategy.Hidden */.l4.Hidden](){s.current[a].state="hidden"}}),D.microTask(()=>{var o;!U(s)&&R.current&&((o=r.current)==null||o.call(r))}))}),x=(0,use_event/* useEvent */.z)(i=>{let e=s.current.find(({el:a})=>a===i);return e?e.state!=="visible"&&(e.state="visible"):s.current.push({el:i,state:"visible"}),()=>p(i,render/* RenderStrategy.Unmount */.l4.Unmount)}),h=(0,react.useRef)([]),v=(0,react.useRef)(Promise.resolve()),u=(0,react.useRef)({enter:[],leave:[],idle:[]}),g=(0,use_event/* useEvent */.z)((i,e,a)=>{h.current.splice(0),n&&(n.chains.current[e]=n.chains.current[e].filter(([o])=>o!==i)),n==null||n.chains.current[e].push([i,new Promise(o=>{h.current.push(o)})]),n==null||n.chains.current[e].push([i,new Promise(o=>{Promise.all(u.current[e].map(([f,N])=>N)).then(()=>o())})]),e==="enter"?v.current=v.current.then(()=>n==null?void 0:n.wait.current).then(()=>a(e)):a(e)}),d=(0,use_event/* useEvent */.z)((i,e,a)=>{Promise.all(u.current[e].splice(0).map(([o,f])=>f)).then(()=>{var o;(o=h.current.shift())==null||o()}).then(()=>a(e))});return (0,react.useMemo)(()=>({children:s,register:x,unregister:p,onStart:g,onStop:d,wait:v,chains:u}),[x,p,s,g,d,u,v])}function Ne(){}let Pe=["beforeEnter","afterEnter","beforeLeave","afterLeave"];function ae(t){var r;let n={};for(let s of Pe)n[s]=(r=t[s])!=null?r:Ne;return n}function Re(t){let n=(0,react.useRef)(ae(t));return (0,react.useEffect)(()=>{n.current=ae(t)},[t]),n}let De="div",le=render/* Features.RenderStrategy */.AN.RenderStrategy;function He(t,n){var Q,Y;let{beforeEnter:r,afterEnter:s,beforeLeave:R,afterLeave:D,enter:p,enterFrom:x,enterTo:h,entered:v,leave:u,leaveFrom:g,leaveTo:d,...i}=t,e=(0,react.useRef)(null),a=(0,use_sync_refs/* useSyncRefs */.T)(e,n),o=(Q=i.unmount)==null||Q?render/* RenderStrategy.Unmount */.l4.Unmount:render/* RenderStrategy.Hidden */.l4.Hidden,{show:f,appear:N,initial:T}=ye(),[l,j]=(0,react.useState)(f?"visible":"hidden"),z=xe(),{register:L,unregister:O}=z;(0,react.useEffect)(()=>L(e),[L,e]),(0,react.useEffect)(()=>{if(o===render/* RenderStrategy.Hidden */.l4.Hidden&&e.current){if(f&&l!=="visible"){j("visible");return}return (0,match/* match */.E)(l,{["hidden"]:()=>O(e),["visible"]:()=>L(e)})}},[l,e,L,O,f,o]);let k=(0,use_latest_value/* useLatestValue */.E)({base:S(i.className),enter:S(p),enterFrom:S(x),enterTo:S(h),entered:S(v),leave:S(u),leaveFrom:S(g),leaveTo:S(d)}),V=Re({beforeEnter:r,afterEnter:s,beforeLeave:R,afterLeave:D}),G=(0,use_server_handoff_complete/* useServerHandoffComplete */.H)();(0,react.useEffect)(()=>{if(G&&l==="visible"&&e.current===null)throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?")},[e,l,G]);let Te=T&&!N,K=N&&f&&T,de=(()=>!G||Te?"idle":f?"enter":"leave")(),H=c(0),fe=(0,use_event/* useEvent */.z)(C=>(0,match/* match */.E)(C,{enter:()=>{H.addFlag(open_closed/* State.Opening */.ZM.Opening),V.current.beforeEnter()},leave:()=>{H.addFlag(open_closed/* State.Closing */.ZM.Closing),V.current.beforeLeave()},idle:()=>{}})),me=(0,use_event/* useEvent */.z)(C=>(0,match/* match */.E)(C,{enter:()=>{H.removeFlag(open_closed/* State.Opening */.ZM.Opening),V.current.afterEnter()},leave:()=>{H.removeFlag(open_closed/* State.Closing */.ZM.Closing),V.current.afterLeave()},idle:()=>{}})),w=se(()=>{j("hidden"),O(e)},z),B=(0,react.useRef)(!1);use_transition_D({immediate:K,container:e,classes:k,direction:de,onStart:(0,use_latest_value/* useLatestValue */.E)(C=>{B.current=!0,w.onStart(e,C,fe)}),onStop:(0,use_latest_value/* useLatestValue */.E)(C=>{B.current=!1,w.onStop(e,C,me),C==="leave"&&!U(w)&&(j("hidden"),O(e))})});let P=i,ce={ref:a};return K?P={...P,className:(0,class_names/* classNames */.A)(i.className,...k.current.enter,...k.current.enterFrom)}:B.current&&(P.className=(0,class_names/* classNames */.A)(i.className,(Y=e.current)==null?void 0:Y.className),P.className===""&&delete P.className),react.createElement(transition_M.Provider,{value:w},react.createElement(open_closed/* OpenClosedProvider */.up,{value:(0,match/* match */.E)(l,{["visible"]:open_closed/* State.Open */.ZM.Open,["hidden"]:open_closed/* State.Closed */.ZM.Closed})|H.flags},(0,render/* render */.sY)({ourProps:ce,theirProps:P,defaultTag:De,features:le,visible:l==="visible",name:"Transition.Child"})))}function Fe(t,n){let{show:r,appear:s=!1,unmount:R=!0,...D}=t,p=(0,react.useRef)(null),x=(0,use_sync_refs/* useSyncRefs */.T)(p,n);(0,use_server_handoff_complete/* useServerHandoffComplete */.H)();let h=(0,open_closed/* useOpenClosed */.oJ)();if(r===void 0&&h!==null&&(r=(h&open_closed/* State.Open */.ZM.Open)===open_closed/* State.Open */.ZM.Open),![!0,!1].includes(r))throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");let[v,u]=(0,react.useState)(r?"visible":"hidden"),g=se(()=>{u("hidden")}),[d,i]=(0,react.useState)(!0),e=(0,react.useRef)([r]);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{d!==!1&&e.current[e.current.length-1]!==r&&(e.current.push(r),i(!1))},[e,r]);let a=(0,react.useMemo)(()=>({show:r,appear:s,initial:d}),[r,s,d]);(0,react.useEffect)(()=>{if(r)u("visible");else if(!U(g))u("hidden");else{let T=p.current;if(!T)return;let l=T.getBoundingClientRect();l.x===0&&l.y===0&&l.width===0&&l.height===0&&u("hidden")}},[r,g]);let o={unmount:R},f=(0,use_event/* useEvent */.z)(()=>{var T;d&&i(!1),(T=t.beforeEnter)==null||T.call(t)}),N=(0,use_event/* useEvent */.z)(()=>{var T;d&&i(!1),(T=t.beforeLeave)==null||T.call(t)});return react.createElement(transition_M.Provider,{value:g},react.createElement(I.Provider,{value:a},(0,render/* render */.sY)({ourProps:{...o,as:react.Fragment,children:react.createElement(ue,{ref:x,...o,...D,beforeEnter:f,beforeLeave:N})},theirProps:{},defaultTag:react.Fragment,features:le,visible:v==="visible",name:"Transition"})))}function _e(t,n){let r=(0,react.useContext)(I)!==null,s=(0,open_closed/* useOpenClosed */.oJ)()!==null;return react.createElement(react.Fragment,null,!r&&s?react.createElement(q,{ref:n,...t}):react.createElement(ue,{ref:n,...t}))}let q=(0,render/* forwardRefWithAs */.yV)(Fe),ue=(0,render/* forwardRefWithAs */.yV)(He),Le=(0,render/* forwardRefWithAs */.yV)(_e),qe=Object.assign(q,{Child:Le,Root:q});

;// CONCATENATED MODULE: ./node_modules/@heroicons/react/outline/esm/CheckCircleIcon.js


function CheckCircleIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = react.forwardRef(CheckCircleIcon);
/* harmony default export */ var esm_CheckCircleIcon = (ForwardRef);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/XIcon.js
var XIcon = __webpack_require__(5506);
;// CONCATENATED MODULE: ./components/Notification/PopUpNotification.js
/* This example requires Tailwind CSS v2.0+ */ 



function PopUpNotification(param) {
    var isShown = param.isShown, fileUploadText = param.fileUploadText, uploadResponse = param.uploadResponse;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "aria-live": "assertive",
            style: {
                zIndex: 999
            },
            className: "pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 ".concat(isShown ? "" : "hidden"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex w-full flex-col items-center space-y-4 sm:items-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(qe, {
                    show: isShown,
                    as: react.Fragment,
                    enter: "transform ease-out duration-300 transition",
                    enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
                    enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
                    leave: "transition ease-in duration-100",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white-light shadow-lg ring-1 ring-black ring-opacity-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "p-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: uploadResponse === "success" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CheckCircleIcon, {
                                            className: "h-6 w-6 text-green",
                                            "aria-hidden": "true"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(XIcon/* default */.Z, {
                                            className: "h-6 w-6 text-red",
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "ml-3 w-0 flex-1 pt-0.5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-grey",
                                            children: fileUploadText
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useEnhancedEffect/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(3546);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/resolveProps/resolveProps.js
var resolveProps = __webpack_require__(5971);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/useThemeProps/getThemeProps.js

function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }
  return (0,resolveProps/* default */.Z)(theme.components[name].defaultProps, props);
}
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useThemeWithoutDefault.js
var useThemeWithoutDefault = __webpack_require__(4168);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
'use client';






/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */

/**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */

/**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */

function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const [match, setMatch] = react.useState(() => {
    if (noSsr && matchMedia) {
      return matchMedia(query).matches;
    }
    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    }

    // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.
    return defaultMatches;
  });
  (0,useEnhancedEffect/* default */.Z)(() => {
    let active = true;
    if (!matchMedia) {
      return undefined;
    }
    const queryList = matchMedia(query);
    const updateMatch = () => {
      // Workaround Safari wrong implementation of matchMedia
      // TODO can we remove it?
      // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };
    updateMatch();
    // TODO: Use `addEventListener` once support for Safari < 14 is dropped
    queryList.addListener(updateMatch);
    return () => {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia]);
  return match;
}

// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseSyncExternalStore = react_namespaceObject['useSyncExternalStore' + ''];
function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const getDefaultSnapshot = react.useCallback(() => defaultMatches, [defaultMatches]);
  const getServerSnapshot = react.useMemo(() => {
    if (noSsr && matchMedia) {
      return () => matchMedia(query).matches;
    }
    if (ssrMatchMedia !== null) {
      const {
        matches
      } = ssrMatchMedia(query);
      return () => matches;
    }
    return getDefaultSnapshot;
  }, [getDefaultSnapshot, query, ssrMatchMedia, noSsr, matchMedia]);
  const [getSnapshot, subscribe] = react.useMemo(() => {
    if (matchMedia === null) {
      return [getDefaultSnapshot, () => () => {}];
    }
    const mediaQueryList = matchMedia(query);
    return [() => mediaQueryList.matches, notify => {
      // TODO: Use `addEventListener` once support for Safari < 14 is dropped
      mediaQueryList.addListener(notify);
      return () => {
        mediaQueryList.removeListener(notify);
      };
    }];
  }, [getDefaultSnapshot, matchMedia, query]);
  const match = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return match;
}
function useMediaQuery(queryInput, options = {}) {
  const theme = (0,useThemeWithoutDefault/* default */.Z)();
  // Wait for jsdom to support the match media feature.
  // All the browsers MUI support have this built-in.
  // This defensive check is here for simplicity.
  // Most of the time, the match media logic isn't central to people tests.
  const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  const {
    defaultMatches = false,
    matchMedia = supportMatchMedia ? window.matchMedia : null,
    ssrMatchMedia = null,
    noSsr = false
  } = getThemeProps({
    name: 'MuiUseMediaQuery',
    props: options,
    theme
  });
  if (false) {}
  let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, '');

  // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
  const useMediaQueryImplementation = maybeReactUseSyncExternalStore !== undefined ? useMediaQueryNew : useMediaQueryOld;
  const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
  if (false) {}
  return match;
}
// EXTERNAL MODULE: ./components/Uploader/Dropbox.js
var Dropbox = __webpack_require__(8369);
;// CONCATENATED MODULE: ./components/PreAuth/RequestLookup.js




var PreAuthRequestLookup = function(param) {
    var click = param.click, isShown = param.isShown, closeModal = param.closeModal, successfulSubmission = param.successfulSubmission, failedSubmission = param.failedSubmission;
    var ref = (0,react.useState)("selectFiles"), uploadStatus = ref[0], setUploadStatus = ref[1];
    var ref1 = (0,react.useState)([]), fileList = ref1[0], setFileList = ref1[1];
    (0,react.useEffect)(function() {
        return function() {
            setUploadStatus("selectFiles");
            setFileList([]);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                zIndex: 999
            },
            className: "\n      ".concat(isShown ? "" : "hidden", "\n      fixed\n      z-10\n      w-full\n      h-full\n      bg-white-light\n      bg-opacity-30\n     inset-0\n       text-center\n    "),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative w-[100%] h-[100%] md:w-[900px] md:h-[560px]",
                style: {
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    background: "white",
                    boxShadow: "0px 0px 70px 0px rgba(0,0,0,0.2)",
                    zIndex: 9999
                },
                children: [
                    (uploadStatus === "success" || uploadStatus === "error") && /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusOverlay, {
                        status: uploadStatus,
                        fileList: fileList,
                        closeModal: closeModal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative flex flex-col items-center h-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-5",
                                style: {
                                    marginBottom: "5%"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-2xl md:text-4xl",
                                        children: "Upload your files"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(XIcon/* default */.Z, {
                                        onClick: closeModal,
                                        className: "absolute w-10 h-10 cursor-pointer right-5 top-5 text-darkBlue",
                                        "aria-hidden": "true"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col h-full max-w-[550px] w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropbox/* default */.Z, {
                                        uploadStatus: uploadStatus,
                                        setUploadStatus: setUploadStatus,
                                        setFileList: setFileList
                                    }),
                                    uploadStatus === "selectFiles" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-[#dbe9fd] mt-2 p-4 border-[#006BFF] border-2 text-left",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "Attach your Prior authorization request form with supporting clinical documentation here. You can submit documents in",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    style: {
                                                        fontWeight: 600
                                                    },
                                                    children: [
                                                        " ",
                                                        "txt, doc, pdf, jpg and png",
                                                        " "
                                                    ]
                                                }),
                                                " ",
                                                "file formats. Please note that the maximum file size is",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        fontWeight: 600
                                                    },
                                                    children: "30mb"
                                                }),
                                                "."
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var StatusOverlay = function(param) {
    var status = param.status, fileList = param.fileList, closeModal = param.closeModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            zIndex: 1000
        },
        className: "absolute inset-0 flex flex-col items-center justify-center flex-1 text-center bg-opacity-90 bg-white-light p-9 backdrop-blur-sm",
        children: [
            status === "success" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-3xl",
                        children: "Successfully uploaded"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center mt-4 p-9",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xl",
                                children: "Here's a summary of the uploaded files"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col items-center w-full p-4 mt-4 overflow-hidden overflow-y-auto max-h-40",
                                children: fileList.map(function(file) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "p-2 mb-2 rounded-md bg-[#dbf4db] drop-shadow-md border-[#5a8e5a] border-1",
                                        children: file
                                    });
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-3xl",
                        children: "Failed to upload"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xl text-center p-14",
                        children: "Unfortunately something went wrong uploading your files. Please contact customer service for further assistance"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "w-[100px] p-2 px-4 mt-2 transition-all duration-200 border shadow-sm bg-[#007bff] border-blue hover:bg-[#1985fa] text-white-light disabled:bg-lightGrey disabled:text-black-default disabled:cursor-not-allowed",
                onClick: closeModal,
                children: "Close"
            })
        ]
    });
};
/* harmony default export */ var RequestLookup = (PreAuthRequestLookup);

// EXTERNAL MODULE: ./constants.js
var constants = __webpack_require__(8148);
// EXTERNAL MODULE: ./utils/recaptcha.js
var recaptcha = __webpack_require__(3575);
// EXTERNAL MODULE: ./components/Recaptcha/RecaptchaModal.js
var RecaptchaModal = __webpack_require__(4559);
// EXTERNAL MODULE: ./hooks/useRecaptchaLoader.js
var useRecaptchaLoader = __webpack_require__(2219);
;// CONCATENATED MODULE: ./pages/prior-authorization.js















var PreAuthorization = function() {
    var classNames = function classNames() {
        for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
            classes[_key] = arguments[_key];
        }
        return classes.filter(Boolean).join(" ");
    };
    (0,useRecaptchaLoader/* default */.Z)();
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(false), isPreAuthModalShown = ref1[0], setIsPreAuthModalShown = ref1[1];
    var ref2 = (0,react.useState)(false), isUploadFileModalShown = ref2[0], setisUploadFileModalShown = ref2[1];
    var ref3 = (0,react.useState)("success"), fileUploadResponse = ref3[0], setFileUploadResponse = ref3[1];
    var ref4 = (0,react.useState)("Choose a file"), fileUploadText = ref4[0], setFileUploadText = ref4[1];
    var ref5 = (0,react.useState)(null), file = ref5[0], setFile = ref5[1];
    var ref6 = (0,react.useState)(false), showCheckbox = ref6[0], setShowCheckbox = ref6[1];
    var ref7 = (0,react.useState)(null), pendingFile = ref7[0], setPendingFile = ref7[1];
    var theme = (0,useTheme/* default */.Z)();
    var fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    var successfulSubmission = function() {
        setFileUploadResponse("success");
        setisUploadFileModalShown(true);
        setFileUploadText("Submitted!");
        setFile(null);
        setTimeout(function() {
            return setisUploadFileModalShown(false);
        }, 8000);
    };
    var failedSubmission = function() {
        setFileUploadResponse("Failed Please Try again");
        setisUploadFileModalShown(true);
        setFileUploadText("Select a File");
        setTimeout(function() {
            return setisUploadFileModalShown(false);
        }, 8000);
    };
    var setFiles = function(event) {
        var ref, ref1;
        setFileUploadText(((ref = event.target.files[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.name) === null || ref1 === void 0 ? void 0 : ref1.slice(0, 15)) + "...");
        setFile(event.target.files[0]);
    };
    var submitFile = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var token, err, formData, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (!file) return [
                            3,
                            7
                        ];
                        setFileUploadText("Uploading...");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            5
                        ]);
                        return [
                            4,
                            (0,recaptcha/* getRecaptchaV3Token */.o)("upload_files")
                        ];
                    case 2:
                        token = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        setFileUploadText("Select a File");
                        return [
                            4,
                            reportError(err)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2
                        ];
                    case 5:
                        formData = new FormData();
                        formData.append("files", file);
                        formData.append("captcha_token.token", token);
                        formData.append("captcha_token.version", "v3");
                        formData.append("captcha_token.provider", "1");
                        return [
                            4,
                            fetch("".concat(constants/* BASE_URL */._, "/Marketing/AuthorizationRequest"), {
                                method: "POST",
                                body: formData
                            })
                        ];
                    case 6:
                        response = _state.sent();
                        if (response.status >= 200 && response.status <= 299) {
                            successfulSubmission();
                        } else if (response.status === 400) {
                            // require v2 checkbox fallback
                            setPendingFile(file);
                            setFileUploadText("Select a File");
                            setShowCheckbox(true);
                        } else {
                            failedSubmission();
                        }
                        return [
                            3,
                            8
                        ];
                    case 7:
                        document.getElementById("preAuthRequestFormFileUpload").click();
                        _state.label = 8;
                    case 8:
                        setFile(null);
                        return [
                            2
                        ];
                }
            });
        });
        return function submitFile(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var faqs = [
        {
            question: "What's the best thing about Switzerland?",
            answer: "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. <br /> Quas cupiditate laboriosam fugiat."
        }, 
    ];
    var closePreAuthModal = function() {
        setIsPreAuthModalShown(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUpNotification, {
                        isShown: isUploadFileModalShown,
                        fileUploadText: fileUploadText,
                        uploadResponse: fileUploadResponse
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            isPreAuthModalShown && /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestLookup, {
                                isShown: isPreAuthModalShown,
                                closeModal: closePreAuthModal,
                                successfulSubmission: successfulSubmission,
                                failedSubmission: failedSubmission
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-x-0 bottom-0 bg-gray-100 h-1/2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mx-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute inset-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "object-cover w-full h-full",
                                                src: "videocallAtDesk.png",
                                                alt: "People working on laptops"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative max-w-screen-xl px-4 py-16 mx-auto md:py-16 lg:py-32",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                className: "text-3xl tracking-tight md:text-5xl text-darkBlue",
                                                children: [
                                                    "Provider resources for ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-globeGreen",
                                                        children: "prior authorization and more"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid grid-cols-12 gap-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-12 md:col-span-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col justify-between h-full p-12 bg-blue-dark",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                    className: "text-3xl text-white",
                                                    children: [
                                                        "Is Prior Authorization ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        "Needed?"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "inline-block px-4 py-2 mt-8 text-xl text-white bg-transparent border-2 border-white-light hover:bg-white-light hover:text-blue-dark w-fit",
                                                    onClick: function() {
                                                        return window.open("/prior-auth-tool", "_self");
                                                    },
                                                    children: "Prior Auth Tool"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-12 md:col-span-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col justify-between h-full p-12 bg-blue",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                    className: "text-3xl text-white",
                                                    children: [
                                                        "Download the ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        "Evry Health ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        "Prior authorization ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        "Request Form"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://api.evryhealth.com/api/v1/Marketing/GetFileContent?id=fe65c691-b5ad-4f36-b433-924eb7257eec",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: "inline-block px-4 py-2 mt-8 text-xl text-white bg-transparent border-2 border-white-light hover:bg-white-light hover:text-blue-dark",
                                                        children: "Download"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-12 md:col-span-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col justify-between h-full p-12 bg-green",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                    className: "text-3xl text-white",
                                                    children: [
                                                        "Upload Evry Health ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        "Prior authorization ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        "Request Form with Supporting Clinical Documentation"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "submit",
                                                    className: "inline-block px-4 py-2 mt-8 text-xl text-white bg-transparent border-2 border-white-light hover:bg-white-light hover:text-green w-fit",
                                                    onClick: function() {
                                                        return setIsPreAuthModalShown(true);
                                                    },
                                                    children: "Upload"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-12 md:col-span-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col justify-between h-full p-12 bg-green",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "text-3xl text-white",
                                                    children: "For Searchable Formulary And Rx Prior authorization List"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://prime.adaptiverx.com/webSearch/index?key=cnhmbGV4LnBsYW4uUGxhblBkZlR5cGUtODA5",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: "inline-block px-4 py-2 mt-8 text-xl text-white bg-transparent border-2 border-white-light hover:bg-white-light hover:text-green",
                                                        children: "Get Started"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-12 md:col-span-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col justify-between h-full p-12 bg-blue-dark",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                    className: "text-3xl text-white",
                                                    children: [
                                                        "Search Our ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        "Directory for ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        "In-network Providers",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        "and Facilities"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://providers.evryhealth.com/",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: "inline-block px-4 py-2 mt-16 text-xl text-white bg-transparent border-2 border-white-light hover:bg-white-light hover:text-blue-dark",
                                                        children: "Search"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-12 md:col-span-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col justify-between h-full p-12 bg-blue",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "text-3xl text-white",
                                                    children: "Find more helpful resources on the Texas Department of Insurance's website"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://www.tdi.texas.gov/hprovider/index.html",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: "inline-block px-4 py-2 mt-16 text-xl text-white bg-transparent border-2 border-white-light hover:bg-white-light hover:text-blue-dark",
                                                        children: "Visit Website"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    showCheckbox && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            position: "fixed",
                            inset: 0,
                            zIndex: 9999,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    background: "rgba(0,0,0,0.5)",
                                    position: "absolute",
                                    inset: 0
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    zIndex: 10000,
                                    background: "#fff",
                                    padding: 20,
                                    borderRadius: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        style: {
                                            marginBottom: 10
                                        },
                                        children: "Please complete the verification to continue"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecaptchaModal/* default */.Z, {
                                        onVerify: function() {
                                            var _ref = (0,_async_to_generator/* default */.Z)(function(token) {
                                                var pending, formData, response;
                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            pending = pendingFile;
                                                            if (!pending) return [
                                                                2
                                                            ];
                                                            formData = new FormData();
                                                            formData.append("files", pending);
                                                            formData.append("captcha_token.token", token);
                                                            formData.append("captcha_token.version", "v2");
                                                            formData.append("captcha_token.provider", "1");
                                                            return [
                                                                4,
                                                                fetch("".concat(constants/* BASE_URL */._, "/Marketing/AuthorizationRequest"), {
                                                                    method: "POST",
                                                                    body: formData
                                                                })
                                                            ];
                                                        case 1:
                                                            response = _state.sent();
                                                            if (response.status >= 200 && response.status <= 299) successfulSubmission();
                                                            else failedSubmission();
                                                            setPendingFile(null);
                                                            setShowCheckbox(false);
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            });
                                            return function(token) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }(),
                                        onError: function() {
                                            setShowCheckbox(false);
                                            failedSubmission();
                                        },
                                        onClose: function() {
                                            return setShowCheckbox(false);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            marginTop: 8,
                                            textAlign: "right"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            className: "px-4 py-2 text-sm",
                                            onClick: function() {
                                                setShowCheckbox(false);
                                            },
                                            children: "Cancel"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var prior_authorization = (PreAuthorization);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [87,160,875,821,774,888,179], function() { return __webpack_exec__(8688); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);